import styled from "styled-components";
import { COLORS } from "../../constant/theme";


export const ChatContainer = styled.div`
    position:relative;

    .chatContent {
        display:flex;
    }
    .chatting{
        width: 70%;
        height: 100vh;
    

    }

    .receiver_name{
        font-weight:bold;
        font-size:24px;
    }

    .chatting .card {
        background:transparent;
    }

    .chat_box {
        height:100%;
    }

    .chatting .messaging{
        width:90%;
        display:flex;
        flex-direction:column;

    }

    .sender_text {
        width: 100%;
        display:flex;
        justify-content:flex-start;
        margin:50px 0;
        
    }

    .sender_text span{
        width: 40%;
        height:70px;
        padding:7px;
        color: #000;
        border-radius: 20px;
        background: #E6E5E6;

    }

    .reciever_text {
        width: 100%;
        display:flex;
        justify-content:flex-end;
        margin:50px 0;
        
    }

    .reciever_text span{
        width: 40%;
        height:70px;
        padding:7px;
        color: #000;
        padding:10px;
        border-radius: 20px;
        background:#fff;
        box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);
    }


    .chat_form {
        position:sticky;
        bottom:5px;
        display:flex;
        justify-content:space-between;
        align-items:center;
        width:100%;
        
        
        background: #FFFFFF;
        border-radius:20px;
        box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.2);
    }

    .chat_form form {
        width:100%;
        display:flex;
        justify-content:space-between;
    }

    .chat_form input {
        border:none;
        width: 700px;
        height:50px;
    }

    .chat_form button {
        width:60px;
        height:60px;
        background:#000;
        color: #fff;
        border-radius:50%;
    }



    .group{
        //overflow-y:scroll;
        width: 30%;
        z-index:1;
        height:100vh;
    }

    .group .card {
        position:fixed;
    }

    .users_header {
        display:flex;
        flex-direction:column;
        justify-content:center;
        margin-bottom:15px;
    }

    .users_section{
        
    }
    .user_profile {
        display:flex;
        align-items:center;
        margin-bottom:20px;
        cursor:pointer;

    }

    .user_profile span{
        font-weight:bold;
    }

    .profile {
        width:30%;
        height:30%;
        
        margin-right: 30px;
        

    }

    #doctor-1{
        background:pink;
    }

    #doctor-2{
        background:#8DB77F;
    }

    #doctor-3{
        background: #D7BA9E;
    }

    #doctor-4{
        background: #9A9DF9;
    }

    .profile img {
        width:100%;
        height:100%;
        border-radius:50%;
    }

`;